/**
 * The page that states who may open what, and who may change it.
 *
 * Only the wording is here — every name and every role on the page is read
 * from the tables the router and the navigation already enforce.
 */
export const PERMISSIONS = {
  hint: 'Diese Übersicht wird aus denselben Tabellen erzeugt, die Navigation und Router auswerten. Sie lässt sich hier nicht ändern. Wer mehrere Rollen hat, darf alles, was eine davon darf.',
  /** Everything outside System. */
  appAreas: 'Anwendung',
  /** The two questions each row answers. */
  mayOpen: 'Lesen',
  mayChange: 'Ändern',
  /** Where a surface is watched rather than worked in. */
  nobody: 'Niemand',
  /** Beside the widest list, where the screens of an area answer narrower. */
  perScreenNote: 'je nach Ansicht enger',

  /** The switcher root uses to look at the app as somebody else. */
  assumeRole: {
    /** On the trigger while root is themselves. */
    label: 'Rolle testen',
    /** On the trigger while a role is being tried on. */
    active: (role: string) => `Als ${role}`,
    /** The way back to root's own role. */
    reset: 'Eigene Rolle',
    hint: 'Zeigt die Oberfläche wie für diese Rolle. Der Server antwortet weiterhin als Root; ein Neuladen der Seite setzt es zurück.',
  },
} as const
